import { DynamicGalleryEnvService } from '@aipb/gulliver/dynamic-gallery/env';
import { inject, Injectable } from '@angular/core';
import { finalize, map, tap } from 'rxjs';
import { DynamicGalleryApiService } from '../../api';
import { DynamicGalleryRepository } from './dynamic-gallery.repository';

@Injectable({ providedIn: 'root' })
export class DynamicGalleryService {
  private repository = inject(DynamicGalleryRepository);

  constructor(private api: DynamicGalleryApiService, private dynamicGalleryEnv: DynamicGalleryEnvService) {}

  requestRootData() {
    this.repository.setLoading(true);
    return this.api.requestData(this.dynamicGalleryEnv.env.apiUrl + '?request=list').pipe(
      tap((data) => {
        this.repository.setData({
          collections: data.collections,
          collection: data.collection,
          navigation: {
            ...data.navigation,
            breadcrumbs: [
              {
                label: 'Domů',
                url: null
              },
              {
                label: data.collection.label,
                url: null
              }
            ]
          }
        });
      }),
      finalize(() => {
        this.repository.setLoading(false);
      })
    );
  }

  requestData(url: string) {
    this.repository.setLoading(true);
    return this.api.requestData(url).pipe(
      map((data) => {
        return {
          ...data,
          navigation: {
            ...data.navigation,
            breadcrumbs: [
              {
                label: 'Domů',
                url: null
              },
              ...data.navigation.breadcrumbs
            ]
          }
        };
      }),
      tap((data) => {
        this.repository.setData({
          collections: data.collections,
          records: data.records,
          collection: data.collection,
          castor: data.castor,
          navigation: {
            ...data.navigation,
            breadcrumbs: [
              ...data.navigation.breadcrumbs,
              {
                label: data.collection.label,
                url: null
              }
            ]
          }
        });
      }),
      finalize(() => {
        this.repository.setLoading(false);
      })
    );
  }
}
